<template>
  <div class="buttonPage absolute_center" :class="{_boxBg_green_secondLevel:styleType == 'typeGreen',_boxBg_dark_secondLevel:styleType == 'typeDark' ,_boxBg_blue_secondLevel:styleType == 'typeBlue', _boxBg_strong_secondLevel: styleType == 'typeStrong',}">
    <div class="selfClose_btn" style="top:10px" @click="close"></div>
    <div class="_boxTitle" :class="{'title-style': isNewMaterialsTable}">
      <span class="default-title" :class="{'isActive': tabIndex === 1}" @click="changeTab(1)">{{title}}</span>
      <span class="line" v-if="isNewMaterialsTable"></span>
      <span class="default-title" v-if="isNewMaterialsTable" :class="{'isActive': tabIndex === 2}" @click="changeTab(2)">物料种类分类列表</span>
    </div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="page1" v-show="detailShow">
        <div class="check_box">
          <el-form :inline="true" class="demo-form-inline secondLevel-form-inline">
            <el-form-item label="日期：">
<!--              <el-date-picker v-model="materialDate" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>-->
              <!-- :picker-options="pickerOptions"
              @calendar-change="handleChange" :disabledDate="disabledDate" -->
              <DatePicker
                :init-width="'420px'"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :currentDateList="materialDate"
                :needInitTime="false"
                :topPx="'50px'"
                :leftPx="'-200px'"
                @dateChange="changeTime"
              >
              </DatePicker>
            </el-form-item>
            <el-form-item :label="labelTitle + '：'">
              <el-input v-model="material" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="排放阶段：">
              <el-select v-model="vehicleEmission" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="国III" :value="3"></el-option>
                <el-option label="国IV" :value="4"></el-option>
                <el-option label="国V" :value="5"></el-option>
                <el-option label="国VI" :value="6"></el-option>
                <el-option label="新能源" :value="99"></el-option>
                <el-option v-if="electricVehicle" label="纯电" :value="199"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label=" ">
              <a class="self_btn" @click="query()">查询</a>
              <a class="self_btn" @click="reset()">重置</a>
              <a class="self_btn" v-if="newAccessType" @click="materialExport">导出</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="table_box" style="height: 600px;">
          <el-table :data="tableData" style="width: 100%" @row-click="rowClick" :header-cell-class-name="'thClass'" :header-row-class-name="'headTrClass'" :cell-class-name="'tdClass'"
            :row-class-name="'trClass'" class="secondLevel_table">
            <el-table-column v-if="labelTitle === '物料名'" prop="transportName" :show-overflow-tooltip="true" :label="labelTitle" align="center"></el-table-column>
            <el-table-column v-if="labelTitle === '物料分类'" prop="transportType" :show-overflow-tooltip="true" :label="labelTitle" align="center"></el-table-column>
            <el-table-column prop="transportVolume" label="物料总重量（吨）" align="center"></el-table-column>
            <el-table-column prop="frequency" label="物料总批次（车次总数）" align="center"></el-table-column>
            <el-table-column v-if="newAccessType || customerId === 113 || customerId === 136 || showVehicles" prop="vehiclesTotal" label="车辆总数" align="center"></el-table-column>
            <el-table-column label="详情" align="center" v-if="customerId != 64">
              <template #default="scope">
                <span class="view" style="cursor:pointer;color:rgb(0, 252, 255)">查看</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page_box secondLevel-pagination_box pagination">
          <el-pagination @current-change="handleCurrentChange" :current-page="params.pageNo" :page-size="params.pageSize" layout="total,prev, pager, next, jumper" :total="page_total"></el-pagination>
          <p>跳转</p>
        </div>
      </div>
      <div class="page2" v-show="!detailShow">
        <div class="selfReturn_btn" style="top:10px" @click="returnClick"></div>
        <div class="check_box">
          <el-form :inline="true" class="demo-form-inline secondLevel-form-inline">
            <el-form-item label="排放阶段：">
              <el-select v-model="vehicleEmission2" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="国III" :value="3"></el-option>
                <el-option label="国IV" :value="4"></el-option>
                <el-option label="国V" :value="5"></el-option>
                <el-option label="国VI" :value="6"></el-option>
                <el-option label="新能源" :value="99"></el-option>
                <el-option  label="纯电" :value="199"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" ">
              <a class="self_btn" @click="query2()">查询</a>
              <a class="self_btn" @click="reset2()">重置</a>
              <a class="self_btn" v-if="newAccessType" @click="materialInfoExport">导出</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="table_box" style="height: 640px;">
          <el-table :data="tableData2" style="width: 100%" @row-click="rowClick2" :header-cell-class-name="'thClass'" :header-row-class-name="'headTrClass'" :cell-class-name="'tdClass'"
            :row-class-name="'trClass'" class="secondLevel_table">
            <el-table-column prop="numberPlate" label="车牌号" align="center"></el-table-column>
            <el-table-column prop="vehicleEmission" v-if="isNewCleanTransport" label="排放阶段" align="center">
            </el-table-column>
            <el-table-column prop="vehicleEmission" v-else label="排放阶段" align="center">
              <template #default="scope">
                <span>{{vehicleEmissionMap[scope.row.vehicleEmission]}}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="labelTitle === '物料名'" prop="transportName" :show-overflow-tooltip="true" :label="labelTitle" align="center"></el-table-column>
            <el-table-column v-if="labelTitle === '物料分类'" prop="transportType" :show-overflow-tooltip="true" :label="labelTitle" align="center"></el-table-column>
            <el-table-column prop="transportVolume" label="物料重量（吨）" align="center"></el-table-column>
            <el-table-column prop="inTime" width="300" :show-overflow-tooltip="true" label="进厂时间" align="center"></el-table-column>
            <el-table-column prop="outTime" width="300" :show-overflow-tooltip="true" label="出厂时间" align="center"></el-table-column>
            <el-table-column prop="completeTime" width="300" :show-overflow-tooltip="true" label="计量完成时间" align="center"></el-table-column>
            <!-- <el-table-column prop="matchType" label="匹配类型" align="center"></el-table-column> -->
          </el-table>
        </div>
        <div class="page_box secondLevel-pagination_box pagination" style="position: relative;">
          <div class="totalWeightStyle" v-if="customerId === 113 || customerId === 136 || isShowWeigh">
            <span>总重量：</span>
            <span>{{ totalWeight }}（吨）</span>
          </div>
          <el-pagination @current-change="handleCurrentChange2" :current-page="params2.pageNo" :page-size="params2.pageSize" layout="total,prev, pager, next, jumper" :total="page_total2">
          </el-pagination>
          <p>跳转</p>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { dateFormat } from "@/utils/tools.js";
import { DatePicker } from "@/modules/commonDatePicker";
import player from "modules/DIYcomponents/components/2_1/keyAreaMonitor/components/component/player";
import scaleBar from "modules/DIYcomponents/components/2_1/keyAreaMonitor/components/component/scaleBar";
import {mapState} from "vuex";
export default {
  name: "vehicleMateria",
  props: ["globalInstance"],
  components: { DatePicker },
  setup(props) {
    const globalInstance = props.globalInstance;
    return { globalInstance };
  },
  data() {
    return {
      electricVehicle: bmeConfig.electricVehicle,
      pageInfo: 'buttonPage.vue',
      computedName: '车辆运输物料运输弹框组件',
      isNewCleanTransport: bmeConfig.isNewCleanTransport,
      title: '物料分类列表',
      newAccessType: this.$store.state.newAccessType,
      isShowWeigh: bmeConfig.isShowWeigh,
      pickDay: "",
      between: 31,
      tableData: [],
      tableData2: [],
      materialDate: [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ],
      material: "",
      material2: "",
      vehicleEmission: "",
      vehicleEmission2: "",
      vehicleEmissionMap: {
         '3': '国III',
         '4': '国IV',
         '5': '国V',
         '6': '国VI',
         '99': '新能源'
      },
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      params2: {
        pageNo: 1,
        pageSize: 10,
      },
      page_total: 0,
      page_total2: 0,
      customerId: this.globalInstance.$store.state.customerId,
      detailShow: true,
      totalWeight: 0,
      showVehicles: bmeConfig.showVehicles,
      isNewMaterialsTable: bmeConfig.isNewMaterialsTable,
      tabIndex: 1,
      labelTitle: '物料名',
    };
  },
  computed: {
    ...mapState({ vehicleTransportTime:'vehicleTransportTime' }),
    styleType() {
      return this.globalInstance.$store.state.styleType;
    },
  },
  mounted() {
    // this.tableData = [
    //   {
    //     transportName: "带钢",
    //     transportVolume: "324",
    //     frequency: "232",
    //   },
    // ];
    if(this.vehicleTransportTime.length > 0) {
      this.materialDate = this.vehicleTransportTime;
    }
    if (bmeConfig.electricVehicle) {
      this.vehicleEmissionMap['199'] = '电车';
    }
    this.getMaterialList();

    this.title = '物料分类列表';

  },

  methods: {
    changeTime(time) {
      this.materialDate = time;
    },
    rowClick(row) {
      this.vehicleEmission2 = row.vehicleEmission
        ? -(-row.vehicleEmission)
        : "";
      this.material2 = row.transportName || row.transportType;
      this.detailShow = false;
      this.totalWeight = row.transportVolume || 0;

      this.title = '物料运输列表';

      switch(this.tabIndex) {
        case 1:
          this.getMaterialList2();
          break;
        case 2:
          this.getNewMaterialList2();
          break;  
      }
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.query();
    },
    handleCurrentChange2(val) {
      this.params2.pageNo = val;
      this.query2();
    },
    query() {
      switch(this.tabIndex) {
        case 1:
          this.getMaterialList();
          break;
        case 2:
          this.getNewMaterialList();
          break;
      }
    },
    query2() {
      switch(this.tabIndex) {
        case 1:
          this.getMaterialList2();
          break;
        case 2:
          this.getNewMaterialList2();
          break;
      }
    },
    reset() {
      this.material = "";
      this.vehicleEmission = "";
      this.materialDate = [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
      this.query()
    },
    reset2() {
      this.vehicleEmission2 = "";
      this.query2();
    },
    handleChange(val) {
      if (this.between) {
        const [pointDay] = val;
        this.pickDay = pointDay;
      }
    },
    disabledDate(time) {
      if (!this.pickDay) {
        return false;
      }
      if (this.between) {
        const con1 =
          new Date(this.pickDay).getTime() - this.between * 24 * 60 * 60 * 1000;
        const con2 =
          new Date(this.pickDay).getTime() + this.between * 24 * 60 * 60 * 1000;
        // return time < con1 || time > con2;
        return time;
      }
      return false;
    },
    async getMaterialList() {
      let that = this;
      let url =
        this.globalInstance.cleanTransportIp + "/transport/transport_material";
      let res = await this.globalInstance.$apiUtils.get3(url, {
        customerId:this.customerId,
        pageNo: that.params.pageNo,
        pageSize: that.params.pageSize,
        material: that.material,
        vehicleEmission: that.vehicleEmission,
        startTime: dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[0]),
        endTime: dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[1]),
      });
      this.tableData = res?.list;
      this.page_total = res?.rowCount;
    },
    async getMaterialList2() {
      let that = this;
      let url_ =
        this.globalInstance.cleanTransportIp +
        "/transport/transport_material_detail";
      let params =  {
        customerId:this.customerId,
        pageNo: that.params2.pageNo,
        pageSize: that.params2.pageSize,
        material: that.material2,
        vehicleEmission: that.vehicleEmission2,
        startTime:  dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[0]),
        endTime: dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[1]),
      }
      let queryString = Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
      let url = `${url_}?${queryString}`;
      let res = await this.globalInstance.$apiUtils.get3(url,);
      this.tableData2 = res.list;
      this.page_total2 = res.rowCount;
    },
    async getNewMaterialList() {
      let that = this;
      let url = bmeConfig.baseUrl + '/bme-access-control/material_classification/static/list'
        // this.globalInstance.cleanTransportIp + "/transport/material_classification/static/list";
      let res = await this.globalInstance.$apiUtils.get3(url, {
        customerId:this.customerId,
        pageNo: that.params.pageNo,
        pageSize: that.params.pageSize,
        materialType: that.material,
        vehicleEmission: that.vehicleEmission,
        startTime: dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[0]),
        endTime: dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[1]),
      });
      this.tableData = res?.list;
      this.page_total = res?.rowCount;
    },
    async getNewMaterialList2() {
      let that = this;
      let url_ = bmeConfig.baseUrl + '/bme-access-control/material_classification/static/detail/list'
        // this.globalInstance.cleanTransportIp +
        // "/transport/transport_material_detail";
      let params =  {
        customerId:this.customerId,
        pageNo: that.params2.pageNo,
        pageSize: that.params2.pageSize,
        materialType: that.material2,
        vehicleEmission: that.vehicleEmission2,
        startTime:  dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[0]),
        endTime: dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[1]),
      }
      let queryString = Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
      let url = `${url_}?${queryString}`;
      let res = await this.globalInstance.$apiUtils.get3(url,);
      this.tableData2 = res.list;
      this.page_total2 = res.rowCount;
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
    /**
     * @Description: 按物料分类导出
     * @author liqiuyu
     * @date 2023/4/19
    */
   
    materialExport() {
      switch(this.tabIndex) {
        case 1:
          this.exportOne();
          break;
        case 2:
          this.exportTwo()
          break;  
      }
    },
    exportOne() {
      let that = this
      this.$message.info('正在导出数据……')
      // CONFIG.newName
      let ip = this.globalInstance.cleanTransportIp;
      let str = `${ip}/transport/transport_material_exportExcel?startTime=${dateFormat('YYYY-mm-dd HH:MM:SS', this.materialDate[0])}&endTime=${dateFormat(
        'YYYY-mm-dd HH:MM:SS',
        this.materialDate[1]
      )}&customerId=${this.customerId}&material=${this.material}&vehicleEmission=${this.vehicleEmission}
      &pageSize=${this.params.pageSize}&pageNo=${this.params.pageNo}
      `
      let a = document.createElement('a')
      a.setAttribute('href', str)
      a.setAttribute('id', 'startTelMedicine')
      // a.target="_blank"
      document.body.appendChild(a)
      a.click()
      let elem = document.getElementById('startTelMedicine')
      elem.parentNode.removeChild(elem)
    },
    exportTwo() {
      let that = this
      this.$message.info('正在导出数据……')
      // CONFIG.newName
      let ip = this.globalInstance.cleanTransportIp;
      let str = bmeConfig.baseUrl + `/bme-access-control/material_classification/static/list/export?startTime=${dateFormat('YYYY-mm-dd HH:MM:SS', this.materialDate[0])}&endTime=${dateFormat(
        'YYYY-mm-dd HH:MM:SS',
        this.materialDate[1]
      )}&customerId=${this.customerId}&materialType=${this.material}&vehicleEmission=${this.vehicleEmission}
      &pageSize=${this.params.pageSize}&pageNo=${this.params.pageNo}
      `
      let a = document.createElement('a')
      a.setAttribute('href', str)
      a.setAttribute('id', 'startTelMedicine')
      // a.target="_blank"
      document.body.appendChild(a)
      a.click()
      let elem = document.getElementById('startTelMedicine')
      elem.parentNode.removeChild(elem)
    },
    /**
     * @Description: 按物料运输导出
     * @author liqiuyu
     * @date 2023/4/19
    */
    materialInfoExport() {
      switch (this.tabIndex) {
        case 1:
          this.materialInfoExportOne()
          break;
        case 2:
          this.materialInfoExportTwo()
          break;  
      }
    },
    materialInfoExportOne() {
      let that = this
      this.$message.info('正在导出数据……')
      // CONFIG.newName
      let ip = this.globalInstance.cleanTransportIp;
      let str = `${ip}/transport/transport_material_detail_exportExcel?startTime=${dateFormat('YYYY-mm-dd HH:MM:SS', this.materialDate[0])}&endTime=${dateFormat(
        'YYYY-mm-dd HH:MM:SS',
        this.materialDate[1]
      )}&customerId=${this.customerId}&material=${this.material2}&vehicleEmission=${this.vehicleEmission2}
      &pageSize=${this.params2.pageSize}&pageNo=${this.params2.pageNo}`;
      let a = document.createElement('a')
      a.setAttribute('href', str)
      a.setAttribute('id', 'startTelMedicine')
      // a.target="_blank"
      document.body.appendChild(a)
      a.click()
      let elem = document.getElementById('startTelMedicine')
      elem.parentNode.removeChild(elem)
    },
    materialInfoExportTwo() {
      let that = this
      this.$message.info('正在导出数据……')
      let ip = this.globalInstance.cleanTransportIp;
      let str = bmeConfig.baseUrl + `/bme-access-control/material_classification/static/detail/list/export?startTime=${dateFormat('YYYY-mm-dd HH:MM:SS', this.materialDate[0])}&endTime=${dateFormat(
        'YYYY-mm-dd HH:MM:SS',
        this.materialDate[1]
      )}&customerId=${this.customerId}&materialType=${this.material2}&vehicleEmission=${this.vehicleEmission2}
      &pageSize=${this.params2.pageSize}&pageNo=${this.params2.pageNo}`;
      let a = document.createElement('a')
      a.setAttribute('href', str)
      a.setAttribute('id', 'startTelMedicine')
      // a.target="_blank"
      document.body.appendChild(a)
      a.click()
      let elem = document.getElementById('startTelMedicine')
      elem.parentNode.removeChild(elem)
    },
    returnClick() {
      this.detailShow = true;
      this.tableData2 = [];
      this.material2 = "";
      this.vehicleEmission2 = "";
      this.params2 = {
        pageNo: 1,
        pageSize: 10,
      };
      this.page_total2 = 0;
      this.title = '物料分类列表';
    },
    changeTab(val) {
      this.tabIndex = val
      this.detailShow = true;
      this.material = "";
      this.vehicleEmission = "";
      switch(val) {
        case 1:
          this.labelTitle = '物料名';
          break;
        case 2: 
          this.labelTitle = '物料分类';
          break;  
      }
      this.query()
    }
  },
  unmounted() {
    this.reset();
  },
};
</script>
<style lang="scss" scoped>
.account {
  width: 100%;
  height: 100%;
  padding: 70px 80px;
  font-size: 20px;
}
.tips {
  text-align: center;
  margin-top: 50px;
}
.demo-form-inline {
  display: flex;
}
.totalWeightStyle {
  font-size: 30px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  color: #05fbf6;
}
.line {
  width: 3px;
  height: 50%;
  background: #05fbf6;
  margin: 0 8px;
}
.default-title:hover{
  color: #05fbf6;
}
.isActive {
  color: #05fbf6;
}
.title-style {
  cursor: pointer;
  color: #afafaf;
}
</style>
<style>
.buttonPage {
  width: 2200px !important;
}
.buttonPage .el-form-item__content {
  display: flex;
  align-items: center;
}
.buttonPage .el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 500px;
}
</style>
<style>
/* 分页 */
.buttonPage .secondLevel-pagination_box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* margin: 30px 100px 0 0; */
  margin: 20px 0 0 0;
}
.buttonPage .secondLevel-pagination_box p {
  font-size: 28px;
}
.buttonPage .secondLevel-pagination_box .el-pagination .el-pagination__total {
  margin-right: 50px;
}
.buttonPage .secondLevel-pagination_box .el-pagination {
  text-align: right;
  padding: 0 130px 0 0;
}
.buttonPage .secondLevel-pagination_box .el-pagination button,
.buttonPage .el-pagination span:not([class*="suffix"]) {
  font-size: 26px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
}
.buttonPage .secondLevel-pagination_box .el-pager li,
.buttonPage .secondLevel-pagination_box .el-pager li.btn-quicknext,
.buttonPage .secondLevel-pagination_box .el-pager li.btn-quickprev {
  font-size: 26px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
  background: transparent;
}
.buttonPage .secondLevel-pagination_box .el-pager li.active {
  color: #55abf9;
}
.buttonPage .secondLevel-pagination_box .el-pagination .btn-next,
.buttonPage .el-pagination .btn-prev,
.buttonPage .el-pagination button:disabled {
  background: transparent;
  color: #ffffff;
}
.buttonPage .secondLevel-pagination_box .el-pagination .btn-next .el-icon,
.buttonPage .el-pagination .btn-prev .el-icon {
  font-size: 28px;
}
.buttonPage .secondLevel-pagination_box .el-pagination__editor.el-input {
  width: 80px;
  height: 50px;
}
.buttonPage
  .secondLevel-pagination_box
  .el-pagination__editor.el-input
  .el-input__inner {
  height: 36px;
  font-size: 22px;
  border: 1px solid #dcdfe6;
  background: transparent;
  color: #fff;
}
._boxBg_blue_secondLevel
  .el-select__popper
  .el-select-dropdown
  .el-scrollbar
  .el-select-dropdown__wrap
  .el-scrollbar__view
  .el-select-dropdown__item {
  color: #fff;
}
.buttonPage .el-form-item__content .el-select {
  height: 40px;
}
.buttonPage .el-form-item__content .el-input__inner {
  height: 40px;
  font-size: 16px;
}
</style>
